import { render, staticRenderFns } from "./abstrRegistPage.vue?vue&type=template&id=04864f0e&scoped=true&"
import script from "./abstrRegistPage.vue?vue&type=script&lang=js&"
export * from "./abstrRegistPage.vue?vue&type=script&lang=js&"
import style0 from "./abstrRegistPage.vue?vue&type=style&index=0&id=04864f0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04864f0e",
  null
  
)

export default component.exports